const generateIds = () => ({
  cc_number_container: {
    title: "Seleccionar identificación",
    class: "Selection",
    description: "Despliega la lista y selecciona tu tipo de identificación"
  },
  id_number_container: {
    title: "Número de identificación",
    class: "Identification",
    description: "Haz clic sobre el rectángulo e ingresa el número"
  },
  phone_number_container: {
    title: "Número de celular",
    class: "PhoneNumber",
    description:
      "Este número será utilizado en caso de que se presente alguna falla en la videollamada"
  },

  "authorizations-container": {
    title: "Autorizaciones médicas",
    class: "Att1",
    description:
      "Haz clic aquí y adjunta tu orden médica, resultados de exámenes si los tienes e historia clínica si cuentas con ella y agiliza tu atención."
  },
  "service_client-container": {
    title: "Prefiero seguir con el asesor",
    class: "Att2",
    description: "Haz clic aquí para esperar a un asesor"
  },
  "add-doc-container": {
    title: "Adjuntar documentos",
    class: "Upload1",
    description: "Haz clic aquí para adjuntar tus documentos"
  },
  "secondadd-doc-container": {
    title: "Adjuntar documentos",
    class: "Upload3",
    description: "Haz clic aquí para adjuntar tus documentos"
  },
  "delete-doc-container": {
    title: "Eliminar documento",
    class: "Upload2",
    description:
      "Si deseas eliminar tu documento presiona sobre el botón rojo con la X"
  },

  "video-tutorial": {
    title: "Video de turnos",
    class: "Att",
    description: "Aquí puedes hacer seguimiento a tu puesto en fila"
  }

  // Aquí puedes hacer seguimiento a tu puesto en fila

  // microphone: {
  //   title: "Micrófono",
  //   class: "Mic",
  //   description: "Haz clic para activar o desactivar el audio"
  // },
  // video_camera: {
  //   title: "Cámara de video",
  //   class: "VideoCam",
  //   description: "Haz clic para activar o desactivar tu cámara"
  // },
  // finish_video_call: {
  //   title: "Colgar la videollamada",
  //   class: "EndVideoCall",
  //   description: "Haz clic, si deseas cancelar la videollamada"
  // },
  // add_files: {
  //   title: "Adjuntar archivos",
  //   class: "AddFiles",
  //   description:
  //     "Haz clic sobre el ícono si deseas adjuntar un archivo para enviar"
  // },
  // write_message: {
  //   title: "Escribe tu mensaje",
  //   class: "WriteMessage",
  //   description: "Haz clic sobre el texto para escribir un mensaje"
  // },
  // send_message: {
  //   title: "Enviar",
  //   class: "SendMessage",
  //   description: "Haz clic sobre el ícono para enviar tu mensaje o archivo"
  // }
});

export default generateIds;
